export default "__VITE_ASSET__ef620ebe__"